/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BalanceOperationControlsEntity } from '../models/BalanceOperationControlsEntity';
import type { UpdateBalanceOperationControlsDto } from '../models/UpdateBalanceOperationControlsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BalanceOperationControlsService {
  /**
   * Xem cấu hình chức năng trừ điểm
   * Trả về trạng thái bật/tắt hiện tại của toàn bộ chức năng có thể làm giảm điểm người dùng. API dành cho SpAdmin và Admin được cấp ScreenAction tương ứng.
   * @returns BalanceOperationControlsEntity Cấu hình chức năng trừ điểm hiện tại.
   * @throws ApiError
   */
  public static balanceOperationControlsControllerGetControls(): CancelablePromise<BalanceOperationControlsEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/server-config/balance-operation-controls',
    });
  }

  /**
   * Cập nhật cấu hình chức năng trừ điểm
   * Cập nhật đồng thời trạng thái bật/tắt của toàn bộ chức năng trừ điểm. Giá trị true là bật, false là tạm ngưng các yêu cầu mới; giao dịch đang xử lý và giao dịch hoàn điểm không bị ảnh hưởng.
   * @param requestBody
   * @returns BalanceOperationControlsEntity Cấu hình sau khi cập nhật thành công.
   * @throws ApiError
   */
  public static balanceOperationControlsControllerUpdateControls(
    requestBody: UpdateBalanceOperationControlsDto,
  ): CancelablePromise<BalanceOperationControlsEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/server-config/balance-operation-controls',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
